import { AdminSectionComponent } from './admin-section/admin-section.component';
import { Navbar } from './navbar.component';

export const NAVBAR_DECLARATIONS: any[] = [
  Navbar , AdminSectionComponent
];
